import { formatDateTime, entryBadge, countExistingBlocks } from '../../utils/historyView';
import { formatNumber, formatDuration } from '../../utils/stats';
import { canResumeEntry, buildConversationChain } from '../../utils/conversation';
import './HistoryTab.css';

function HistoryTab({ entries, selectedId, existingBlockIds, busy, onSelect, onViewResponse, onResume, onReplay, onRemoveBlocks, onDeleteEntry, onClearHistory }) {
    return (
        <>
            <div className="ai_chat_panel_insights_hint">
                Stored in this browser only (never in the database). The API key is never saved.
            </div>
            {entries.length === 0 &&
                <div className="ai_chat_panel_stats_empty">Nothing here yet. Each AI answer for this bot is kept here.</div>
            }
            {entries.map((entry) => {
                const badge = entryBadge(entry, existingBlockIds);
                const existing = countExistingBlocks(entry, existingBlockIds);
                const canReplay = entry.status !== 'clarification' && entry.steps.length > 0;

                return (
                    <div
                        key={entry.id}
                        className={'ai_chat_panel_history_item' + (entry.id === selectedId ? ' selected' : '')}
                        onClick={() => onSelect(entry.id)}
                    >
                        <div className="ai_chat_panel_history_item_top">
                            <span className="ai_chat_panel_history_item_date">{formatDateTime(entry.createdAt)}</span>
                            <span className={'ai_chat_panel_badge ' + badge.className}>{badge.label}</span>
                        </div>
                        <div className="ai_chat_panel_history_item_prompt">{entry.prompt || '(no prompt)'}</div>
                        {entry.error && <div className="ai_chat_panel_history_item_error">{entry.error}</div>}
                        <div className="ai_chat_panel_history_item_meta">
                            {entry.blocks.length > 0 && <span>{existing}/{entry.blocks.length} blocks on canvas</span>}
                            {entry.stats && <span>{formatNumber(entry.stats.total_tokens)} tokens</span>}
                            {entry.stats && <span>{formatDuration(entry.stats.duration_ms)}</span>}
                            {canResumeEntry(entry) && buildConversationChain(entry, entries).length > 1 && <span>conversation of {buildConversationChain(entry, entries).length}</span>}
                        </div>
                        <div className="ai_chat_panel_history_item_actions" onClick={(e) => e.stopPropagation()}>
                            <button type="button" className="ai_chat_panel_small_button" onClick={() => onViewResponse(entry.id)}>Response</button>
                            {canResumeEntry(entry) &&
                                <button type="button" className="ai_chat_panel_small_button primary" disabled={busy} onClick={() => onResume(entry)} title="Continue this conversation: Teia remembers the exchanges that led to this answer">Resume</button>
                            }
                            {canReplay &&
                                <button type="button" className="ai_chat_panel_small_button" disabled={busy} onClick={() => onReplay(entry)} title="Create these blocks again from the stored JSON (no AI call)">Re-create</button>
                            }
                            {existing > 0 &&
                                <button type="button" className="ai_chat_panel_small_button danger" disabled={busy} onClick={() => onRemoveBlocks(entry)} title="Delete the blocks of this generation from the canvas">Delete blocks</button>
                            }
                            <button type="button" className="ai_chat_panel_small_button" disabled={busy} onClick={() => onDeleteEntry(entry)} title="Remove this entry from the history (the canvas is not touched)">Forget</button>
                        </div>
                    </div>
                );
            })}
            {entries.length > 0 &&
                <button type="button" className="ai_chat_panel_small_button danger wide" disabled={busy} onClick={onClearHistory}>Clear history of this bot</button>
            }
        </>
    );
}

export default HistoryTab;
